<template>
    <div class="reset-password">
        <form @submit.prevent="resetPassword" class="main-form">
            <custom-input
                v-model="password"
                inputType="password"
                :title="$t('WEBSHOPS__PASSWORD')"
                helperText="Minimum 7 Symbols"
                :isError="passwordError"
                errorMessage="Must Be Minimum 7 symbols!"
            />
            <custom-input
                v-model="confirm"
                inputType="password"
                :title="$t('WEBSHOPS__CONFIRM_PASSWORD')"
                :isError="confirmError"
                errorMessage="Passwords Don't Match!"
            />
            <button class="btn">{{ $t('WEBSHOPS__SAVE') }}</button>
        </form>
    </div>
</template>

<script>
import CustomInput from '@/components/ReusableComponents/CustomInput/CustomInput.vue'
import axios from '@/Helpers/AxiosInstance.js'
export default {
    components: {
        CustomInput,
    },
    props: {
        webshopID: Number,
    },
    data() {
        return {
            password: '',
            confirm: '',
            passwordError: false,
            confirmError: false,
        }
    },
    methods: {
        resetPassword() {
            if (this.checkForErrors()) return
            axios
                .post('WebShop/ChangeWebShopPassword', {
                    webShopId: this.webshopID,
                    password: this.password,
                })
                .then(resp => {
                    if (resp.data.status == 1) {
                        this.$emit('done', {
                            purpose: 'success',
                            text: 'Password Reset Is Successful!',
                        })
                    } else {
                        this.emitError(resp.data.status)
                    }
                })
                .catch(() => {
                    this.emitError()
                })
        },
        checkForErrors() {
            if (this.password.length < 7) {
                this.passwordError = true
                return true
            } else if (this.confirm != this.password) {
                this.confirmError = true
                return true
            }
            this.passwordError = false
            this.confirmError = false
            return false
        },
        emitError(status) {
            var text = 'An Error Has Occurred While Reseting Password!'
            var code = this.statusCodes.filter(e => e.key == status)[0]
            if (code) text = this.$t('STATUS-CODE__' + code.value)
            this.$emit('done', {
                purpose: 'error',
                text: text,
            })
        },
    },
    computed: {
        statusCodes() {
            return this.$store.state.statusCodes
        },
    },
}
</script>

<style lang="scss" scoped>

.reset-password {
    margin-top: 60 * $rem;
}

form {
    display: flex;

    label {
        margin-right: 15 * $rem;
    }
}
</style>